// extracted by mini-css-extract-plugin
export var hideEditor = "_n0-2";
export var infoIcon = "_n0-3";
export var label = "_n0-1";
export var labelContainer = "_n0-0";
export var readonlyText = "_n0-4";